export const scrollToPage = (index: number) => {
    document.querySelector(`#page-${index}`)?.scrollIntoView({ behavior: "smooth", block: "start" });
};
